// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { MenuItem } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import i18n from '../../../i18n';
import { currencyConfig } from '../../../config/currency.config';

export default class AgentTransactionsPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'accountingAgentTransactions';
        this.Server =
            this.props.context.getState().server.accountingAgentTransactions;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['agent.name', 'systemAccount.name', 'comment'];

        this.Head = localStorage[`head_${this.Name}`]
            ? JSON.parse(localStorage[`head_${this.Name}`])
            : [
                {
                    id: 'agentId',
                    label: 'agent',
                    alignRight: false,
                    cell: 'Select',
                    displayGrid: true,
                    from: 'publicAgents',
                    object: 'agent',
                    show: 'name'
                },
                {
                    id: 'systemAccountId',
                    label: 'systemAccount',
                    alignRight: false,
                    cell: 'Select',
                    displayGrid: true,
                    from: 'accountingSystemAccounts',
                    object: 'systemAccount',
                    show: 'name'
                },
                {
                    id: 'systemAmount',
                    label: 'systemAmount',
                    alignRight: false,
                    cell: 'Amount',
                    displayGrid: true,
                },
                {
                    id: 'terminalAmount',
                    label: 'terminalAmount',
                    alignRight: false,
                    cell: 'Amount',
                    displayGrid: true,
                },
                {
                    id: 'terminalCurrency',
                    label: 'terminalCurrency',
                    alignRight: false,
                    cell: 'Items',
                    type: 'currency',
                    noTranslate: true,
                    items: Object.keys(currencyConfig),
                    displayAdd: true,
                    displayGrid: true
                },
                {
                    id: 'comment',
                    label: 'comment',
                    alignRight: false,
                    cell: 'BigText',
                    displayGrid: true,
                },
                {
                    id: 'paymentDate',
                    label: 'paymentDate',
                    alignRight: false,
                    cell: 'Date',
                    displayGrid: true,
                    default: 'today',
                },
                {
                    id: 'modifiedReason',
                    label: 'modifiedReason',
                    alignRight: false,
                    cell: 'BigText',
                    displayGrid: true,
                    disableEditor: true
                },
                {
                    id: 'modifiedBy',
                    label: 'modifiedBy',
                    alignRight: false,
                    cell: 'Select',
                    object: 'modifiedBy',
                    show: 'firstName+lastName',
                    displayGrid: true,
                    disableEditor: true,
                    customSort: 'modifiedBy.firstName',
                },
                {
                    id: 'dateCreatedModified',
                    elements: ['dateCreated', 'dateModified'],
                    label: 'dateCreatedModified',
                    alignRight: false,
                    cell: 'CreateModify',
                    disableEditor: true,
                    displayGrid: true,
                    customSort: 'dateCreated',
                },
            ];
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
    renderCustomMenuItems() {
        return [
            <MenuItem
                key="showDetails"
                onClick={(event) => this.handleShowDialogDetails(event)}
            >
                <InfoIcon sx={{ mr: 2, width: '20px' }} />
                {i18n.t('common.showDetails')}
            </MenuItem>
        ];
    }
}
